import React from "react";
import "./EllipsisLoader.css";

const EllipsisLoader = () => {
  return (
    <div className="ellipsis-loader">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};

export default EllipsisLoader;
